export const webEmbedTab = {
  scope: {
    title: "Czego ma szukać wyszukiwarka na stronie?",
    only: "Tylko",
    thisListing: "tę ofertę",
    hint: "Zalecane, jeśli kod zostanie wklejony na stronie tego obiektu. Wyłącz tę opcję, aby wyszukiwarka pokazywała wszystkie obiekty.",
  },
  where: {
    title: "Gdzie mają pojawiać się obiekty?",
    hint: 'Pasek wyszukiwania wygląda tak samo we wszystkich trzech przypadkach. Zmienia się tylko to, co dzieje się po kliknięciu przycisku "Szukaj" przez odwiedzającego.',
    ariaLabel: "Miejsce wyświetlania dostępności",
    ownFields: {
      name: "Mam już własny pasek wyszukiwania",
      hint: "Nie dodamy naszego paska: użyj własnych pól i przekaż nam wyszukiwanie",
    },
  },
  modes: {
    overlay: {
      name: "Pływające okno nad stroną",
      tag: "Zalecane",
      desc: "Lista otwiera się w oknie nad stroną i zamyka się przyciskiem X. Strona się nie przesuwa: odwiedzający wraca dokładnie w to samo miejsce.",
    },
    inline: {
      name: "Wewnątrz strony",
      desc: "Lista pojawia się na własnej stronie jak kolejna sekcja: przewija się razem z resztą treści i nie ma czego zamykać. Miejsce jej wyświetlania wybierasz samodzielnie.",
    },
    tab: {
      name: "W nowej karcie",
      desc: "Pasek pozostaje na stronie, a po wyszukaniu rezerwacja jest kontynuowana w innej karcie. To najprostsza opcja, ale odwiedzający rezerwuje już poza stroną.",
    },
  },
  modeNote: {
    overlay: "Pasek wyszukiwania zachowuje stałą wysokość i się nie zmienia: lista i cały proces rezerwacji odbywają się w pływającym oknie, z własnym przewijaniem.",
    inline: "Tutaj rośnie tylko sekcja z listą, czyli dokładnie to, co ma rosnąć. Pasek wyszukiwania nadal zajmuje tyle samo miejsca, a kalendarz otwiera się nad nim, niczego nie przesuwając.",
    tab: "Osadzony jest tylko pasek. Cała reszta odbywa się w silniku rezerwacji, w osobnej karcie.",
  },
  webs: {
    bahia: "Strona z sekcją hero",
    cala: "Strona minimalistyczna",
  },
  fondos: {
    white: "Białe (domyślne)",
    transparent: "Przezroczyste · przejmuje tło strony",
  },
  appearance: {
    title: "Wygląd",
    buttonColor: "Kolor przycisku",
    background: "Tło paska wyszukiwania",
    language: "Język",
  },
  preview: {
    title: "Jak to wygląda na stronie internetowej",
    hint: "Przykładowa strona z gotowym paskiem wyszukiwania. To prawdziwy widget: wybierz daty i kliknij Szukaj, aby zobaczyć, jak działa.",
    openFull: "Otwórz w pełnym rozmiarze",
    testIn: "Testuj na",
    testInAriaLabel: "Przykładowa strona internetowa",
    missingUuid: "Brakuje identyfikatora konta do wygenerowania widgetu.",
    fakeUrl: "twoja-strona.com",
    iframeTitle: "Podgląd widgetu na przykładowej stronie internetowej",
  },
  guide: {
    title: "Jak dodać to na swojej stronie",
    hint: 'Działa na każdej stronie: HTML, WordPress (blok "Custom HTML"), Wix, Squarespace, Shopify… Nic nie trzeba instalować.',
    warn: "<b>Jeśli Twoja strona to Wix, Squarespace lub Shopify</b>, dwie sprawy: w <b>edytorze</b> blok z kodem zawsze wygląda na pusty (działa dopiero w trybie \"Podgląd\" albo po opublikowaniu), a ponieważ te platformy umieszczają pasek wyszukiwania we własnej ramce, <b>wszystko dzieje się w jej wnętrzu</b>: kalendarz i lista obiektów. Dlatego <b>rozciągnij ją do około 900 px wysokości</b> w edytorze; jeśli będzie za niska, kalendarz zostanie ucięty. Resztą zajmiemy się my: nie zmieniaj kodu.",
    missingUuid: "Brakuje identyfikatora konta do wygenerowania kodu.",
    copy: "Kopiuj",
    copied: "Skopiowano",
    saveReload: "Zapisz i odśwież swoją stronę",
  },
  steps: {
    script: {
      title: "Wklej to tam, gdzie ma pojawić się pasek wyszukiwania",
      titleOwn: "Wklej to raz, w dowolnym miejscu strony",
      hint: "Dokładnie tam, gdzie ma być pasek z datami: sekcja hero, pasek pod menu, panel boczny…",
      hintOwn: "Sam z siebie niczego nie wyświetla: przygotowuje rezerwację dla Twojego własnego formularza.",
      after: "Pasek zachowuje stałą wysokość i nie zmienia rozmiaru, więc nie zaburzy układu strony.",
    },
    target: {
      title: "Wklej ten slot tam, gdzie ma pojawić się lista",
      hint: 'Zwykle jest to osobna sekcja pod sekcją hero, z własnym nagłówkiem nad nią ("Dostępność", "Nasze obiekty"…).',
      after: "Dopóki nikt nie wyszuka, ten slot nie zajmuje miejsca. Jeśli zostanie pominięty, lista pojawi się tuż pod paskiem wyszukiwania.",
    },
    api: {
      title: "Połącz swoje pola z wyszukiwaniem",
      hint: "Zachowujesz własny design, ale kalendarz może być nasz: ten, który pokazuje cenę każdej nocy, minimalny pobyt i zajęte dni.",
      after: "Jeśli wolisz własne pola z datami, to też zadziała: przekaż nam daty w formacie YYYY-MM-DD bezpośrednio do WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Kopiowanie ręczne",
    manualCopyDetail: "Twoja przeglądarka nie pozwoliła na automatyczne skopiowanie. Kod jest już zaznaczony.",
  },
};
